import React from "react";
import "./Feature.css";
import FeatureIcon from "../home/feature-icon1/FeatureIcon";

const Feature = () => {
  return (
    <div className="container-fluid">
      <div className="">
        <div className="d-none d-lg-block d-xl-block ">
          <div className="">
            <FeatureIcon></FeatureIcon>
            <div>
              <hr />
            </div>
            {/* <FeatureIcon2></FeatureIcon2> */}
            <div className="d-none d-lg-block d-xl-block"></div>
            <div className="d-none d-lg-block d-xl-block"></div>
          </div>
        </div>
        <div className="d-none d-md-none d-lg-none d-xl-block"></div>
      </div>
    </div>
  );
};

export default Feature;
